module.exports = __webpack_public_path__ + "static/img/Frame-4.9117d1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Frame-4.png
// module id = 5dvw
// module chunks = 1